import "./index.scss";

export default function SmartPlayTag({marginLeft = 0 }){
    return (
        <div style={{marginLeft}} className='smart-play-tag'>SP</div>
    )
}